var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.33398V13.996C14.0006 14.0835 13.984 14.1703 13.951 14.2515C13.9181 14.3326 13.8695 14.4064 13.808 14.4688C13.7466 14.5311 13.6734 14.5807 13.5928 14.6148C13.5121 14.6489 13.4255 14.6667 13.338 14.6673H2.662C2.48654 14.6673 2.31826 14.5977 2.19413 14.4737C2.07 14.3497 2.00018 14.1814 2 14.006V1.99532C2 1.63732 2.29933 1.33398 2.668 1.33398H9.998L14 5.33398ZM12.6667 6.00065H9.33333V2.66732H3.33333V13.334H12.6667V6.00065ZM5.33333 4.66732H7.33333V6.00065H5.33333V4.66732ZM5.33333 7.33398H10.6667V8.66732H5.33333V7.33398ZM5.33333 10.0007H10.6667V11.334H5.33333V10.0007Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.db807fe2194ba127bd2f39541fb1536d.svg";
export { ForwardRef as ReactComponent };